import React, { Fragment, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import  { Button } from 'react-bootstrap'

import { usePrevious } from '../../../hooks/usePrevious'

import PrimaryInfectionSiteOption from './PrimaryInfectionSiteOption'
import CustomCheckboxOptionModal from './CustomCheckboxOptionModal'

import { setCustomPrimaryInfectionSiteWarning } from '../reducers/infectionCourseFormReducer'

const PrimaryInfectionSiteOptions = (props) => {
  const [showCustomOptionModal, setShowCustomOptionModal] = useState(false)
  const [infectionSiteToPatch, setInfectionSiteToPatch] = useState(null)
  
  const previouslySaving = usePrevious(props.disabled)

  const checkIfSaveIsComplete = () => {
    const saving = props.disabled
    if (showCustomOptionModal && saving === false && previouslySaving === true && !props.showWarning && !props.warningMessage) {
      setShowCustomOptionModal(false)
      setInfectionSiteToPatch(null)
    }
  }

  useEffect(checkIfSaveIsComplete)

  
  const handleUpdateNestedFieldViaModal = (infectionSite) => {
    setInfectionSiteToPatch(infectionSite)
    setShowCustomOptionModal(true)
  }

  const handleOnConfirmPatch = (updatedName) => {
    const updatedInfectionSite = {
      ...infectionSiteToPatch,
      infection_site_description: updatedName,
    }
    return props.handlePrimarySitesBlur(updatedInfectionSite)
  }

  const handleCancel = () => {
    setShowCustomOptionModal(false)
    setInfectionSiteToPatch(null)
  }

  const { 
    primary_infection_sites, 
    displayTabs, 
    chartForReview,
  } = props

  const infectionSiteOptions = [
    {
      displayName: 'Blood',
      fieldName: 'blood'
    },
    {
      displayName: 'Respiratory',
      fieldName: 'respiratory',
      nestedLabel: 'What sample was taken?',
      nestedName: 'infection_site_description',
      selectFields: [
        {
          displayName: 'Endotracheal or Transtracheal Aspirate',
          fieldName: 'infection_site_description'
        },
        {
          displayName: 'BAL or mini-BAL',
          fieldName: 'infection_site_description'
        },
        {
          displayName: 'Sputum',
          fieldName: 'infection_site_description'
        },
        {
          displayName: 'Other',
          fieldName: 'infection_site_description'
        },
        {
          displayName: 'Not Done',
          fieldName: 'infection_site_description'
        },
      ]
    },
    {
      displayName: 'Urinary',
      fieldName: 'urinary'
    },
    {
      displayName: 'Intra-Abdominal',
      fieldName: 'primaryInfectionSite'
    },
    {
      displayName: 'Bone/Joint',
      fieldName: 'boneJoint'
    },
    {
      displayName: 'Skin and Skin Structure',
      fieldName: 'skinAndSkinStructure'
    },
  ]

  
  const primaryInfectionSiteOtherSelections = primary_infection_sites.filter((site) => {
    return site.infection_site.toLowerCase() === 'other'
  })
  
  // const checkCustomFieldsBeforeSavingPrimarySites = () => {
  //   const incompleteCustomFields = primaryInfectionSiteOtherSelections.filter(site => {
  //     return !site.infection_site_description
  //   })

  //   if (incompleteCustomFields.length > 0) {
  //     return props.setCustomPrimaryInfectionSiteWarning('Warning: Please enter a name for all custom infection sites. If you wish to remove the custom infection site, click the checkbox next to it.')
  //   }

  //   return props.savePrimarySites()
  // }

  return (
    <Fragment>
      {infectionSiteOptions.map(option => {
        const primaryInfectionSite = primary_infection_sites.find(site => site.infection_site === option.displayName)
        const optionIsSelected = !!primaryInfectionSite

        return (
          <PrimaryInfectionSiteOption
            key={option.fieldName}
            primaryInfectionSite={primaryInfectionSite}
            infectionSiteOptions={infectionSiteOptions}
            option={option}
            optionIsSelected={optionIsSelected}
            disabled={props.disabled}
            nestedFieldDisabled={props.nestedFieldDisabled}
            handlePrimarySiteSelect={() => props.handlePrimarySiteSelect(option.displayName, !optionIsSelected)}
            required={props.getRequired(infectionSiteOptions)}
            getValue={props.getValue}
            handlePrimarySiteNestedFieldsChange={(e) => props.handlePrimarySiteNestedFieldsChange(e, option)}
            handlePrimarySitesBlur={props.handlePrimarySitesBlur}
          />
        )
      })}

      {primaryInfectionSiteOtherSelections.map((selection, index) => {
        const option = {
          id: selection.id,
          displayName: 'Other',
          fieldName: 'other-' + index,
          textFields: [
            {
              displayName: 'Name',
              fieldName: 'infection_site_description'
            }
          ]
        }
        return (
          <PrimaryInfectionSiteOption
            key={option.fieldName}
            primaryInfectionSite={selection}
            infectionSiteOptions={infectionSiteOptions}
            option={option}
            optionIsSelected
            disabled={props.disabled}
            nestedFieldDisabled={props.nestedFieldDisabled}
            handlePrimarySiteSelect={() => props.handlePrimarySiteSelect(option.displayName, false, selection)}
            required={props.getRequired(infectionSiteOptions)}
            getValue={props.getValue}
            handlePrimarySiteNestedFieldsChange={(e) => props.handlePrimarySiteNestedFieldsChange(e, selection)}
            handlePrimarySitesBlur={props.handlePrimarySitesBlur}
            handleNestedFieldClick={handleUpdateNestedFieldViaModal}
            preventChange
          />
        )
      })}

      {displayTabs ?
        null
        :
        <>
          <Button
            variant='secondary'
            disabled={chartForReview}
            onClick={() => setShowCustomOptionModal(true)}
          >
            Add Other Infection Site
          </Button>

          <br />
          <br />
        </>
      }

      {showCustomOptionModal ?
        <CustomCheckboxOptionModal
          show={showCustomOptionModal}
          onCancel={handleCancel}
          modelName="Infection Site"
          headerText="Add Other Infection Site"
          showAlertMessage={props.showWarning}
          toggleAlertMessage={(message) => props.setCustomPrimaryInfectionSiteWarning(message)}
          alertMessage={props.warningMessage}
          bodyText="Enter a name for the infection site"
          formValue={infectionSiteToPatch ? infectionSiteToPatch.infection_site_description : ''}
          formPlaceholder="Enter name"
          onConfirm={(primarySiteDescription) => props.handlePrimarySiteSelect('Other', true, null, primarySiteDescription)}
          onConfirmPatch={(updatedName) => handleOnConfirmPatch(updatedName)}
          onConfirmMethod={infectionSiteToPatch ? 'PATCH' : 'POST'}
          disabled={props.disabled}
        />
        :
        null
      }

      <Button
        disabled={chartForReview}
        onClick={displayTabs || chartForReview ? props.hideTabs : props.savePrimarySites}
      >
        {displayTabs ? "Edit Infection Sites" : "Save Infection Sites"}
      </Button>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    showWarning: state.infectionCourseFormReducer.showPrimaryInfectionSiteWarning,
    warningMessage: state.infectionCourseFormReducer.primaryInfectionSiteWarningMessage
  }
}

const mapDispatchToProps = {
  setCustomPrimaryInfectionSiteWarning,
}

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryInfectionSiteOptions)